import {
  GET_ALL_SELECT_QUERY_SUCCESS,
GET_ALL_SELECT_QUERY_REQUEST,
GET_ALL_SELECT_QUERY_ERROR
  } from "./types";
  
  import { BASEURL } from "../../constant/config.js";
  import axios from "axios";
  
  export const getAllSelectQuery = (token, payload) => (dispatch) => {
    dispatch({ type: GET_ALL_SELECT_QUERY_REQUEST });
    return axios({
      method: "POST",
      url: `${BASEURL}getAll/selectQuery`,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: payload,
    })
      .then((response) => {
        return dispatch({
          type: GET_ALL_SELECT_QUERY_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        return dispatch({
          type: GET_ALL_SELECT_QUERY_ERROR,
          payload: error.response,
        });
      });
  };
  